import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { Resource } from './resource_builder';
import { ResourceCategory } from './resource_category_builder';
import { ResourceInfo } from './resource_info_builder';
import { ResourceLocation } from './resource_location_builder';

export interface IResourceDetail extends Resource {
  resource: Resource;
  resource_category: number | ResourceCategory;
  location: number | ResourceLocation;
  resource_detail: ResourceInfo[];
}

export class ResourceDetailBuilder {
  constructor(
    private ngResourceDatastore: IDatasource<Resource>,
    private ngResourceInfoDatastore: IDatasource<ResourceInfo>,
    private ngResourceLocationDatastore: IDatasource<ResourceLocation>,
    private ngResourceCategoryDatastore: IDatasource<ResourceCategory>,
    private ResourceLinksEnum: any
  ) {}

  public buildResourceDetail(resource: Resource): IResourceDetail {
    const resource_category = _4.first(
      this.ngResourceCategoryDatastore.query(
        (currentCategory: ResourceCategory) => currentCategory.id === resource.resource_category
      )
    );
    const location = _4.first(
      this.ngResourceLocationDatastore.query(
        (currentLocation: ResourceLocation) => currentLocation.id === resource.location
      )
    );
    const resource_detail = _4.map(
      this.ngResourceInfoDatastore.query((currentInfo: ResourceInfo) => currentInfo.resource === resource.id),
      (currentInfo: ResourceInfo) => {
        const type = this.ResourceLinksEnum.get(currentInfo.resource_display_type);
        currentInfo.resource_display_type = _4.isUndefined(type) ? this.ResourceLinksEnum.GENERIC : type;
        return currentInfo;
      }
    );

    return _4.merge(resource, {
      resource_category,
      location,
      resource_detail
    }) as IResourceDetail;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/builders/resource_detail_builder.ts